import { Button } from '@mui/material';

import GreenCheckmark from '../../../images/green-checkmark-filled.svg';

interface AIOOutcomeSaveButtonProps {
  isSubmitting: boolean;
  isFormValid: boolean;
  handleSave: () => void;
}

export const AIOOutcomeSaveButton: React.FC<AIOOutcomeSaveButtonProps> = ({
  isSubmitting,
  isFormValid,
  handleSave,
}) => {
  return (
    <Button
      fullWidth
      variant="contained"
      onClick={handleSave}
      disabled={!isFormValid || isSubmitting}
      data-submitting={isSubmitting}
      sx={{
        py: 2.25,
        borderRadius: 2.5,
        fontFamily: 'DM Sans',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: isSubmitting ? '19.20px' : 1.2,
        textTransform: 'none',
        backgroundColor: isSubmitting ? 'white' : 'black',
        color: isSubmitting ? 'black !important' : 'white',
        wordWrap: isSubmitting ? 'break-word' : 'normal',
        border: isSubmitting ? '2px solid black' : 'none',
        outline: isSubmitting ? '2px solid black' : 'none',
        outlineOffset: isSubmitting ? '-1px' : '0',
        '&:hover': {
          backgroundColor: isSubmitting ? 'white' : '#333',
        },
        '&:disabled': {
          backgroundColor: isSubmitting ? 'white' : 'black',
          opacity: isSubmitting ? 1 : 0.3,
          color: isSubmitting ? 'black !important' : 'white',
          border: isSubmitting ? '2px solid black' : 'none',
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        // Override any parent styles when submitting
        ...(isSubmitting && {
          '& *': {
            color: 'black !important',
            fontFamily: 'DM Sans !important',
            fontWeight: '600 !important',
            fontSize: '16px !important',
            lineHeight: '19.20px !important',
            wordWrap: 'break-word !important',
          },
        }),
      }}
    >
      {isSubmitting ? (
        <>
          Submitted!
          <img src={GreenCheckmark} alt="Submitted" width="20" height="20" />
        </>
      ) : (
        'Save outcome'
      )}
    </Button>
  );
};
